import { MantineThemeOverride } from '@mantine/core';

export type TextTheme = NonNullable<MantineThemeOverride['components']>['Text'];

export const Text: TextTheme = {
  // todo: define
};
